import {InjectionToken} from '@angular/core';

export const REPORTING_CONFIG = new InjectionToken('mydocma-reporting-config');

export interface ReportingConfig {
  apiUrl: string;
  virtualDeviceScalingOptions: number;
  rtfShareObjectsThreshold: number;
  printerless?: boolean;
}
